import { useState } from "react";
import {
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import AddLoyalityPoints from "../../Modals/addLoyalityPoint";
import SwapVertIcon from '@mui/icons-material/SwapVert';

const AdjustedPointsTable = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);

  const [status, setStatus] = useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const [rows] = useState([
    {
      id: 1,
      type: "Add Points",
      points: "+50",
      reason: "--",
      date: "03-Sep-2025 10:30 AM"
    },
    {
      id: 2,
      type: "Remove Points",
      points: "-10",
      reason: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi molestias provident ea tempore sed odit voluptatum nihil architecto dolores saepe.",
      date: "02-Sep-2025 05:15 PM"
    }
  ]);

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search..."
          />
          <div className="form">
            <Select
              fullWidth
              value={status}
              onChange={handleStatusChange}
            >
              <MenuItem disabled value="default">
                Points Type
              </MenuItem>
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Add">Add Points</MenuItem>
              <MenuItem value="Remove">Remove Points</MenuItem>
            </Select>
          </div>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => setOpenModal(true)}
          >
            <SwapVertIcon /> Adjust Points
          </Button>
        </div>
      </div>

      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date & Time</TableCell>
              <TableCell>Points Type</TableCell>
              <TableCell>Points</TableCell>
              <TableCell>Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>
                  <p
                    className={`status_btn ${row.type === "Add Points"
                      ? "c_success"
                      : row.type === "Remove Points"
                        ? "c_danger"
                        : "c_warning"
                      }`}
                  >

                    {row.points}
                  </p>
                </TableCell>
                <TableCell className="max_c2">{row.reason}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddLoyalityPoints
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default AdjustedPointsTable;
